import React from 'react';
import { KEYBOARD_ROWS, HOME_KEYS } from './fingerKeyMap';

/**
 * Classic tutor-style virtual keyboard with home / active / target highlights
 */
export default function VirtualKeyboard({
  highlightKeys = [],
  activeKey = '',
  homeOnly = false,
}) {
  const highlightSet = new Set(
    (highlightKeys || []).map((k) => String(k).toLowerCase()),
  );
  const active = String(activeKey || '').toLowerCase();

  return (
    <div className="fg-keyboard-wrap">
      <div className="fg-keyboard">
        {KEYBOARD_ROWS.map((row, rowIndex) => (
          <div key={rowIndex} className="fg-keyboard-row">
            {row.map((key) => {
              const isHome = HOME_KEYS.has(key);
              const isActive = active === key;
              const isHighlight = highlightSet.has(key);
              let className = 'fg-key';
              if (homeOnly && isHome) className += ' fg-key-home';
              if (!homeOnly && isHome) className += ' fg-key-home-soft';
              if (isHighlight) className += ' fg-key-highlight';
              if (isActive) className += ' fg-key-active';
              return (
                <span key={key} className={className}>
                  {key === ';' ? ';' : key.toUpperCase()}
                </span>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
